export function getTextStyle() {
    let textStyle = {
        fontFamily: 'notoSans'
    }
    return textStyle;
}